<template>
  <div id="app" >
    <index/>
  </div>
</template>

<script>
import index from './views/Index.vue'

export default {
  name: 'App',
  components: {
    index
  }
}
</script>

